"use client"

import type { Stripe } from "@stripe/stripe-js"
import { createContext, type ReactNode, useContext, useEffect, useState } from "react"

import { getClientStripe } from "@/utils/client/stripe/getClientStripe"

interface StripeContextType {
  stripe: Stripe | null
}

const StripeContext = createContext<StripeContextType | undefined>(undefined)

export function StripeProvider({ children }: { children: ReactNode }) {
  const [stripe, setStripe] = useState<Stripe | null>(null)

  useEffect(() => {
    ;(async () => {
      const stripe = await getClientStripe()
      setStripe(stripe)
    })()
  }, [])

  return <StripeContext.Provider value={{ stripe }}>{children}</StripeContext.Provider>
}

export function useStripe() {
  const context = useContext(StripeContext)
  if (!context) {
    throw new Error("useStripe must be used within a StripeProvider")
  }
  return context
}
